import { createAxiosClient } from '../axiosDefaults';
export function createApi(baseURL, config) {
  let axiosConfig = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  const instance = createAxiosClient({
    baseURL,
    withCredentials: true,
    ...axiosConfig
  }, config);

  function searchBranches(_ref) {
    let {
      location,
      hash,
      limit,
      specialAreas,
      ipAddress,
      enableBranchPreselection = true,
      slotAvailabilityMaxDays
    } = _ref;
    const options = ipAddress ? {
      headers: {
        'x-forwarded-for': ipAddress
      }
    } : {};
    return instance.post('/consumer/branch-list/search', {
      hash,
      limit,
      location,
      specialAreas,
      excludedBranchIds: [],
      // This field is mandatory, but in our case it's always empty
      enableBranchPreselection,
      slotAvailabilityMaxDays
    }, options);
  }

  function searchClosestBranches(_ref2) {
    let {
      carleadId,
      countryCode,
      distance,
      limit
    } = _ref2;
    return instance.post('/consumer/branch/closest/search', {
      carleadId,
      countryCode,
      distance,
      limit
    });
  }

  return {
    searchBranches,
    searchClosestBranches
  };
}